import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { throwError } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {
  OrgContactUserInterface, OrgContactUserInterfaceWithId,
  OrgUserInterface,
  OrgUserInterfaceWithId
} from '@sk/sk-interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { LocalStorageService } from 'services/local-storage.service';
import { fromPromise } from 'rxjs/internal-compatibility';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private firestoreService: AngularFirestore,
              private storageService: LocalStorageService,
              private httpClient: HttpClient) {
  }


  /**
   *
   * @param orgUid
   */
  queryFirestoreCurrentUserById(organizationId: string, orgUid: string) {
    console.log('ORG ID:  =>', organizationId);
    console.log(`RUN CURRENT USER QUERY - ${moment().format('HH:mm:ss')}`);
    const userRef = this.firestoreService.collection('organizations').doc(organizationId) .collection('users').doc(orgUid)
     console.log(userRef.ref.path)
    return userRef.snapshotChanges()
      .pipe(
        map(res => {
          const data = res.payload.data() as OrgUserInterface;
          const id = res.payload.id;
          const exists = res.payload.exists;
          return  {...data, id, exists } as OrgUserInterfaceWithId;
        }));
  }


  /**
   *
   * @param formValue
   */
  addClientUser(formValue: OrgContactUserInterface) {
    // If the user you are adding is a staff member, update the internal staff list.
    // Don't update the dictionary unless this staff member is active
    if (formValue.type !== 'client') {
      return throwError(new Error('Please submit org user of type client'));
    }
    const updateObject : any = {
      ...formValue
    }
    if(updateObject.id){
      delete  updateObject.id
    }
    if(updateObject.exist || updateObject.exist === false){
      delete  updateObject.exist
    }
    const organizationId = this.storageService.getOrganizationId();
    return fromPromise(this.firestoreService.collection('organizations').doc(organizationId)
      .collection('users').add(formValue))
      .pipe(
        map(res => {
          const id = res.id;
          const exists = true;
          return  {...formValue, id, exists} as OrgContactUserInterfaceWithId;
        }));
  }


  /**
   *
   * @param clientUser
   * @param userId
   */
  updateClientUser(clientUser: OrgContactUserInterfaceWithId, userId: string) {
    // If the user you are adding is a staff member, update the internal staff list.
    // Don't update the dictionary unless this staff member is active
    if (clientUser.type !== 'client') {
      return throwError(new Error('Please submit org user of type client'));
    }

    const updateUser = {
      ...clientUser
    }

    if (updateUser.id !== undefined) {
      delete updateUser.id;
    }

    if (updateUser.exists !== undefined) {
      delete updateUser.exists;
    }

    const organizationId = this.storageService.getOrganizationId();
    return fromPromise(this.firestoreService.collection('organizations').doc(organizationId)
      .collection('users').doc(userId).update(updateUser))
      .pipe(
        map(() => {
          const id = userId;
          const exists = true;
          return {...clientUser, id ,exists } as OrgContactUserInterfaceWithId;
        }));
  }

  /**
   *
   * @param email
   */
  checkEmailNotTakenOrganizationUser(email: string) {
    const organizationId = this.storageService.getOrganizationId();
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection('users',
        ref => ref.where('email', '==', email)).snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as OrgUserInterface;
          const id = a.payload.doc.id;
          const exists = a.payload.doc.exists;
          return {...data, id, exists} as OrgUserInterfaceWithId;
        }))
      );

  }


  /**
   *
   * @param organizationUid
   */
  inactivateOrganizationUser(organizationUid: string) {

    if (!organizationUid) {
      return throwError(new Error('Invalid OrganizationUid'));
    }

    const payload = {
      organizationUid
    };
    return this.httpClient.post(environment.api_url + '/inActivateOrganizationUser', payload)
      .pipe(
        take(1)
      );
  }


  /**
   *
   * @param organizationUid
   */
  reactivateOrganizationUser(organizationUid: string) {

    if (!organizationUid) {
      return throwError(new Error('Invalid OrganizationUid'));
    }


    const payload = {
      organizationUid
    };
    return this.httpClient.post(environment.api_url + '/reactivateOrganizationUser', payload)
      .pipe(
        take(1)
      );
  }


}

